module.exports = __webpack_public_path__ + "img/supplierEntryGuidelines_01.5d9398b5.png";